import { render } from "./TabDocuments.vue?vue&type=template&id=73894f5e&scoped=true"
import script from "./TabDocuments.vue?vue&type=script&lang=js"
export * from "./TabDocuments.vue?vue&type=script&lang=js"

import "./TabDocuments.vue?vue&type=style&index=0&id=73894f5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73894f5e"]])

export default __exports__